export default __webpack_public_path__ + "static/media/settings.6820afd3.svg";